<template>
    <div class="timeout">
        <div class="timeout-close">
            <button
                type="button"
                @click="handleCloseIframe"
                class="web-close-btn"
                :class="{ hidden: !adaptStateToDevice() }"
            >
                <svg
                    width="46"
                    height="46"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="23"
                        cy="23"
                        r="22.629"
                        fill="#fff"
                        stroke="#DEDEDE"
                        stroke-width=".742"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M21.586 23l-6.293-6.293a1 1 0 011.414-1.414L23 21.586l6.293-6.293a1 1 0 011.414 1.414L24.414 23l6.293 6.293a1 1 0 01-1.414 1.414L23 24.414l-6.293 6.293a1 1 0 01-1.414-1.414L21.586 23z"
                        fill="#637381"
                    />
                </svg>
            </button>
        </div>
        <div class="timeout-body">
            <div class="timeout-header__wrapper" :class="{ hidden: !adaptStateToDevice() }">
            </div>
            <article role="alert" class="timeout-wrapper">
                <div class="timeout-img">
                    <figure ref="timeout"></figure>
                </div>
                <h4 class="container__col-sm-12 container__col-md-12 timeout-title">
                    Session Timeout
                </h4>
                <!-- <p class="container__col-sm-6 container__col-md-6 timeout-sub-text">
                    Timeout
                </p> -->
            </article>
        </div>
        <div class="sm__close">
            <button class="sm__close-btn" @click="handleCloseIframe">
                {{ $t("ui.close.btn") }}
            </button>
        </div>
        <secured-by-flutterwave />
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { injectStore } from "redux-vuex";
import { loadAnimation } from "lottie-web";
import timeoutImg from "@/assets/lottie/timeout";
import SecuredByFlutterwave from "@/components/secured-by-flutterwave";

export default {
    name: "PaymentTimeout",
    components: {
        SecuredByFlutterwave,
    },
    setup() {
        const timeout = ref(null);
        const store = injectStore("");
        function loadLottie() {
            loadAnimation({
                container: timeout.value,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: timeoutImg,
                rendererSettings: {
                    progressiveLoad: true,
                    hideOnTransparent: true,
                },
            });
        }

        function handleCloseIframe(state) {
            store.Control.close(state);
        }

        onMounted(() => {
            loadLottie();
        });

        return {
            handleCloseIframe,
            timeout,
        };
    },
};
</script>

<style lang="scss" scoped>
figure {
  height: 8rem;
}

.timeout {
    width: 100%;
    padding: 0 20%;
    margin: 0 auto;
    padding-top: 15rem;
  @media screen and (max-width: $breakpoint-middle * 1px) {
    z-index: 9999;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 0;
    bottom: 0;
    padding: 0;
    position: absolute;
    background: $white;
  }
  &-img {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    img {
      width: min-content;
      margin: 0 auto;
    }
  }
  &-title {
    font-size: 2.4rem;
    line-height: 2rem;
    font-weight: 400;
    text-align: center;
    color: $primary-color;
    font-weight: 600;
    margin-bottom: 0;
  }
  &-sub-text {
    line-height: 2.1rem;
    text-align: center;
    font-weight: $font-light;
    color: $secondary-color;
    width: 90%;
    margin: 0 auto;
    font-size: 1.8rem;
    margin-top: 1.45rem;
  }
  &-header__wrapper {
    margin-bottom: 3.4rem;
  }
  &-body{
      max-width: 382px;
      width: 100%;
      margin: 0 auto;
  }
}

.web-close-btn {
  @media screen and (max-width: $breakpoint-middle - 1 * 1px) {
    display: none;
  }
  display: flex;
  border: none;
  justify-content: flex-end;
  /* margin-right: 9vw; */
  margin-bottom: 1rem;
  background: inherit;
  svg {
    cursor: pointer;
  }
}
.timeout-close {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.sm__close {
    @include screen(menner) {
        display: none;
    }
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 1.5rem;
    
    &-btn {
        color: $red;
        font-weight: bold;
    }
}
</style>